import { PermissionsEnum } from '@/auth/interfaces';
import { useCheckPermissions } from '@/shared';
import { SaveSector } from '../../shared/components/SaveSector';

export type CreateSectorPageProps = {};

const CreateSectorPage: React.FC<CreateSectorPageProps> = () => {
  useCheckPermissions(PermissionsEnum.api_add_sector);

  return <SaveSector titlePage="Crear sector" enableUploadFile={true} />;
};

export default CreateSectorPage;
